<template>
    <div>
        <div class="col-md-12">
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                        <router-link :to="{name:'home'}">{{$t("inicio")}}</router-link>
                    </li>
                    <li class="breadcrumb-item">
                        <router-link :to="{name:'informes'}">{{$t("informes")}}</router-link>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">{{$t("ventasPorRangosHorarios")}}</li>
                </ol>
            </nav>
        </div>
        <CabeceraInformes
            :idBusiness="idBusiness"
            :listBusinesses="listBusinesses"
            :idTpv="idTpv"
            :listTpv="listTpv"
            :dateto="dateto"
            :datefrom="datefrom"
            id="cabecera"
            :conTodos="true"
        />
        <template v-if="!permiso">
            <div class="alert alert-danger m-3" style="width: 100%" role="alert">
                Lo sentimos. Este negocio no cuenta con este módulo activado.
            </div>
        </template>
        <!--<div class="col-md-12">
            <div class="card">
                <div class="row">
                    <div class="col-md-3">
                        <div class="form-group">
                            <label for="listBusiness">{{$t("negocio")}}</label>

                            <el-select class="select-default"
                                       size="large"
                                       v-model="idBusiness"
                                       filterable
                                       :placeholder="$t('seleccionaNegocio')"
                                       @change="getTpv(),idsTPV=[]">
                                <el-option v-for="business in listBusinesses"
                                           class="select-primary"
                                           :value="business.id"
                                           :label="business.establishmentName"
                                           :key="business.establishmentName">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group">

                            <label for="listTPV">{{$t("TPV")}}</label>

                            <div class="row">
                                <div class="col-8">
                                    <el-select class="select-default"
                                               size="large"
                                               v-model="idTpv"
                                               filterable
                                               @change="changeTPV()"
                                               :placeholder="$t('seleccionaTpv')">
                                        <el-option v-for="tpv in listTpv"
                                                   class="select-primary"
                                                   :value="tpv.id"
                                                   :label="tpv.nameShow"
                                                   :key="tpv.nameShow">
                                        </el-option>
                                    </el-select>
                                </div>

                                <div class="col-4">
                                    <button class="btn btn-primary"
                                            @click="openModal()"><i
                                            class="fa fa-filter"></i>
                                    </button>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="col-md-2">
                        <div class="form-group">
                            <label>{{$t("fechaInicio")}}</label>
                            <datetime
                                    value-zone="Europe/Madrid"
                                    :auto="true"
                                    class="theme-numier"
                                    format="dd-MM-yyyy"
                                    :title="$t('fechaInicio')"
                                    :phrases="{ok: $t('aceptar'), cancel: $t('salir')}"
                                    input-class="form-control"
                                    v-model="datefrom"></datetime>
                        </div>

                    </div>

                    <div class="col-md-2">
                        <div class="form-group">
                            <label>{{$t("fechaFin")}}</label>
                            <datetime
                                    value-zone="Europe/Madrid"
                                    :auto="true"
                                    class="theme-numier"
                                    :title="$t('fechaFin')"
                                    format="dd-MM-yyyy"
                                    :phrases="{ok: $t('aceptar'), cancel: $t('salir')}"
                                    input-class="form-control"
                                    v-model="dateto"></datetime>
                        </div>

                    </div>

                    <!--<div class="col-md-4" v-if="!busquedaPorHoras">
                        <div class="form-group">
                            <label>Fecha</label>
                            <el-date-picker
                                    v-model="value4"
                                    type="daterange"
                                    format="dd-MM-yyyy"
                                    start-placeholder="Fecha incio"
                                    end-placeholder="Fecha fin">
                            </el-date-picker>
                        </div>
                    </div>

                    <div class="col-md-4" v-else>
                        <div class="form-group">
                            <label>Fecha</label>
                            <el-date-picker
                                    v-model="value4"
                                    type="datetimerange"
                                    format="dd-MM-yyyy HH:mm"
                                    start-placeholder="Fecha incio"
                                    end-placeholder="Fecha fin">
                            </el-date-picker>
                        </div>
                    </div>-->


                    <!--<div class="col-md-2">
                        <label>&nbsp;</label>
                        <div style="text-align: center" class="form-group">
                            <button class="btn btn-primary"
                                    @click="getVentas()">
                                <img src="static/img/sync.gif" alt="" v-if="loading" width="20">
                                {{$t("consultar")}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>-->


        <div class="col-md-12" v-else-if="respuesta">
            <template v-show="data.length>0">

                <div class="row justify-content-between div-export">
                    <div class="col-md-9 text-left">
                        <el-dropdown>
                            <el-button type="primary" size="small">
                                <i class="fa fa-file"></i>
                                {{$t("exportarInforme")}}<i class="el-icon-arrow-down el-icon--right"></i>
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <a :href="urlExportPDF">
                                    <el-dropdown-item class="text-danger">
                                        <strong><i class="fa fa-file-pdf"></i> {{$t("exportarPdf")}}</strong>
                                    </el-dropdown-item>
                                </a>
                                <a :href="urlExportExcel">
                                    <el-dropdown-item class="text-success">
                                        <strong><i class="fa fa-file-excel"></i> {{$t("exportarExcel")}}</strong>
                                    </el-dropdown-item>
                                </a>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>

                    <div class="col-md-3 consultarSwitch text-right">
                        <span v-if="consultarInicioCuenta">{{$t("informeAperturaCuentas")}}</span>
                        <span v-else>{{$t("informeCierreCuentas")}}</span>
                        <el-switch
                          v-model="consultarInicioCuenta"
                          active-color="#13ce66"
                          inactive-color="#bcbcbc"
                        >
                        </el-switch>
                        <!--<el-checkbox v-model="consultarInicioCuenta">Consultar por inicio de cuenta</el-checkbox>-->
                    </div>
                </div>

                <div class="table-responsive">
                    <table class="table table-bordered table-striped tableVentas text-nowrap">
                        <thead class="thead-dark">
                        <tr>

                            <th rowspan="2" style="text-align: center">{{$t("fecha")}}</th>
                            <th colspan="3" v-for="r in rangosHorarios" style="text-align: center">
                                {{r.name}}
                            </th>
                            <th colspan="3" style="text-align: center">
                                {{$t('totales')}}
                            </th>
                        </tr>
                        <tr>
                            <template v-for="r in rangosHorarios">
                                <th>{{$t("ops")}}.</th>
                                <th>{{$t("comensales")}}</th>
                                <th>{{$t("importe")}}</th>
                            </template>
                            <th>{{$t("ops")}}.</th>
                            <th>{{$t("comensales")}}</th>
                            <th>{{$t("importe")}}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="obj in data" class="trDay">
                            <td>
                                <span :class="getClassDay(obj.initDate)">{{obj.initDate | getDia}}
                                    {{obj.initDate | parseDate}}</span>
                            </td>
                            <template v-for="ran in obj.rangos">
                                <td align="center">{{ran.numOperaciones }}</td>
                                <td align="center">{{ran.numComensales }}</td>
                                <td align="right">{{ran.amount | currency}}</td>

                            </template>
                            <td align="right">{{getTotalnumOperacionesOfRangos(obj.rangos)}}</td>
                            <td align="right">{{getTotalNumComenOfRangos(obj.rangos) }}</td>
                            <td align="right">{{getTotalVentasOfRangos(obj.rangos) | currency}}</td>
                        </tr>
                        </tbody>
                        <tfoot>
                        <tr>
                            <td class="table-success"><strong>{{$t("total")}} </strong></td>

                            <template v-for="r in rangosHorarios">
                                <td class="table-success" align="center">
                                    <strong>{{getOps(data,r.name)}}</strong>
                                </td>
                                <td class="table-success" align="center">
                                    <strong>{{getComensales(data,r.name)}}</strong>
                                </td>

                                <td class="table-success" align="right">
                                    <strong>{{getTotal(data,r.name) | currency}}</strong>
                                </td>
                            </template>

                            <td align="right" class="table-success"><strong>{{totalOperaciones }}</strong></td>
                            <td align="right" class="table-success"><strong>{{totalComensales }}</strong></td>
                            <td align="right" class="table-success"><strong>{{totalVentas | currency}}</strong></td>

                        </tr>

                        </tfoot>
                    </table>
                </div>

                <div class="row">

                    <div class="col-md-12">
                        <hr>
                    </div>
                    <div class="col-md-6">
                        <h5>{{$t("detalleDeOperaciones")}}</h5>
                        <div class="table-responsive">
                            <table class="table table-bordered table-striped tableVentas text-nowrap">
                                <thead class="thead-dark">
                                <tr>
                                    <th>{{$t("rango")}}</th>
                                    <th>{{$t("operaciones")}}</th>
                                    <th>{{$t("total")}}</th>
                                    <th>{{$t("operacionMedia")}}</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="r in rangosHorarios">
                                    <td>{{r.name}}</td>
                                    <td align="center">{{getOps(data,r.name)}}</td>
                                    <td align="right">{{getTotal(data,r.name) | currency}}</td>
                                    <td align="right">{{(getTotal(data,r.name) / getOps(data,r.name)) | currency}}</td>
                                </tr>
                                </tbody>
                                <tfoot>
                                <tr>
                                    <td class="table-success"><strong>{{$t("total")}}</strong></td>
                                    <td class="table-success" align="center"><strong>{{getTotalOps(data)}}</strong></td>
                                    <td class="table-success" align="right"><strong>{{getTotalTotal(data) |
                                        currency}}</strong></td>
                                    <td class="table-success" align="right"><strong>{{(getTotalTotal(data) /
                                        getTotalOps(data)) | currency}}</strong></td>
                                </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>

                    <div class="col-md-6">
                        <div class="chart-container">
                            <canvas id="chartOperaciones" style="height:250px; width: 100%;"></canvas>
                        </div>
                    </div>

                    <div class="col-md-12">
                        <hr>
                    </div>

                    <div class="col-md-6">
                        <h5>{{$t("detalleDeComensales")}}</h5>
                        <div class="table-responsive">
                            <table class="table table-bordered table-striped tableVentas text-nowrap">
                                <thead class="thead-dark">
                                <tr>
                                    <th>{{$t("rango")}}</th>
                                    <th>{{$t("comensales")}}</th>
                                    <th>{{$t("total")}}</th>
                                    <th>{{$t("comensalMedio")}}</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="r in rangosHorarios">
                                    <td>{{r.name}}</td>
                                    <td align="center">{{getComensales(data,r.name)}}</td>
                                    <td align="right">{{getTotal(data,r.name) | currency}}</td>
                                    <td align="right">{{(getTotal(data,r.name) / getComensales(data,r.name)) |
                                        currency}}
                                    </td>
                                </tr>
                                </tbody>
                                <tfoot>
                                <tr>
                                    <td class="table-success"><strong>{{$t("total")}}</strong></td>
                                    <td class="table-success" align="center">
                                        <strong>{{getTotalComensales()}}</strong>
                                    </td>
                                    <td class="table-success" align="right"><strong>{{getTotalTotal() |
                                        currency}}</strong></td>
                                    <td class="table-success" align="right"><strong>{{(getTotalTotal() /
                                        getTotalComensales()) | currency}}</strong></td>
                                </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>

                    <div class="col-md-6">
                        <div class="chart-container">
                            <canvas id="chartComensales" style="height:250px; width: 100%;"></canvas>
                        </div>
                    </div>
                </div>

            </template>
            <template v-if="data.length<=0">

                <div class="alert alert-danger" role="alert">
                    {{$t("noHayVentasEnLosRangosDeFechasDefinidos")}}
                </div>
            </template>

        </div>
    </div>
</template>
<script>
    import {
        DatePicker,
        Select,
        Option,
        Dropdown,
        DropdownItem,
        DropdownMenu,
        Button,
        Checkbox,
        CheckboxGroup,
        Loading,
        Switch
    } from 'element-ui'
    import swal from 'sweetalert2'
    import moment from 'moment'
    import CabeceraInformes from "../../../../components/CabeceraInformes/CabeceraInformes";
    import bus from '../../../../bus'
    import Cierre from './Widgets/Cierre'
    import Tickets from './Widgets/Tickets'
    import Incidencias from './Widgets/Incidencias'
    import Agencias from './Widgets/Agencias'
    import { mapState } from 'vuex'

    export default {
        created() {
            this.loading = Loading.service({ text: "Cargando..." });
            this.$store.dispatch("setNameRoute", this.$i18n.t("ventasPorRangosHorarios"));
            this.getBusiness();

            if (this.$store.getters.dateTo && this.$store.getters.dateFrom) {

                this.datefrom = this.$store.getters.dateFrom;
                this.dateto = this.$store.getters.dateTo;

            }

        },

        components: {
            CabeceraInformes,
            [DatePicker.name]: DatePicker,
            [Select.name]: Select,
            [Dropdown.name]: Dropdown,
            [DropdownItem.name]: DropdownItem,
            [DropdownMenu.name]: DropdownMenu,
            [Button.name]: Button,
            [Option.name]: Option,
            [Checkbox.name]: Checkbox,
            [CheckboxGroup.name]: CheckboxGroup,
            [Switch.name]: Switch,
            Cierre,
            Tickets,
            Incidencias,
            Agencias
        },
        data() {
            return {
                loading: null,
                datefrom: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString(),
                dateto: new Date().toISOString(),
                hoursfrom: "00:00:00",
                hoursto: "23:59:00",
                listBusinesses: [],
                data: [],
                listTpv: [],
                idTpv: 0,
                value4: [new Date(new Date().getFullYear(), new Date().getMonth(), 1), new Date()],
                cuentasAparcadas: false,
                dateInform: [],
                dateRangeOptions1Comercial: {
                    firstDayOfWeek: 1,
                },
                objectChartOps: null,
                objectChartComensales: null,
                consultarInicioCuenta: false,
                idBusiness: 0,
                observar: 0,
                idsTPV: [],
                listCheckBoxTpv: [],
                rangosHorarios: [],

                respuesta:true,

            }
        },
        watch: {
            consultarInicioCuenta() {
                this.getVentas();
            },
        },
        computed: {
            ...mapState(["permiso"]),
            totalVentas() {

                let total = 0;

                this.data.forEach(function (x) {
                    x.rangos.forEach(function (z) {
                        total += z.amount;
                    });

                });

                return total;
            },
            totalOperaciones() {

                let total = 0;

                this.data.forEach(function (x) {
                    x.rangos.forEach(function (z) {
                        total += z.numOperaciones;
                    });

                });

                return total;
            },
            totalComensales() {

                let total = 0;

                this.data.forEach(function (x) {
                    x.rangos.forEach(function (z) {
                        total += z.numComensales;
                    });

                });

                return total;
            },

            urlExportPDF() {

                var tpv = "";

                this.idsTPV.forEach(function (d) {
                    tpv += d + ',';
                });

                return this.$store.getters.apiUrl+"/rangosHorarios/exportVentasRangoHorario/PDF?idBusiness=" + this.idBusiness + "&idTpv=" + tpv + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt + "&diferenciaHoraria=" + Intl.DateTimeFormat().resolvedOptions().timeZone + "&consultarInicioCuenta=" + this.consultarInicioCuenta
            },
            urlExportExcel() {

                var tpv = "";

                this.idsTPV.forEach(function (d) {
                    tpv += d + ',';
                });

                return this.$store.getters.apiUrl+"/rangosHorarios/exportVentasRangoHorario/Excel?idBusiness=" + this.idBusiness + "&idTpv=" + tpv + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt + "&diferenciaHoraria=" + Intl.DateTimeFormat().resolvedOptions().timeZone + "&consultarInicioCuenta=" + this.consultarInicioCuenta
            },

        },
        methods: {

            getTotal(list, rango) {

                let total = 0;
                list.forEach(function (x) {
                    x.rangos.forEach(function (d) {
                        if (d.name === rango) {
                            total += d.amount;
                        }
                    })
                });

                return total;
            },

            cambioBusiness(idBusinessData, listTpv) {
                if (listTpv) {
                    this.listTpv = listTpv;
                }
                this.loading = Loading.service({ text: "Cargando..." });
                this.idBusiness = idBusinessData;
                this.idTpv = -1;
                this.list = [];
                this.cambioTpv(this.idTpv);
            },
            emitirConsulta() {
                this.getVentas();
            },
            cambioTpv(idTpvData, filtrar) {
                if (idTpvData != undefined) {
                    this.idTpv = idTpvData;
                    this.changeTPV();
                }
                
                this.emitirConsulta();
            },
            cambioHora(dates) {
                this.datefrom = dates[0];
                this.dateto = dates[1];
            },

            getOps(list, rango) {

                let total = 0;
                list.forEach(function (x) {
                    x.rangos.forEach(function (d) {
                        if (d.name === rango) {
                            total += d.numOperaciones;
                        }
                    })
                });

                return total;
            },
            changeTPV() {
                if (this.idTpv === -1) {


                    this.idsTPV = [];

                    for (let i = 0; i < this.listTpv.length; i++) {

                        //this.idsTPV.push(this.listCheckBoxTpv[i].id)
                        this.idsTPV.push(this.listTpv[i].id);
                    }
                }
                else {

                    this.idsTPV = []
                    this.idsTPV.push(this.idTpv)

                }
                //this.getSalesProducts();
            }
            ,
            getComensales(list, rango) {

                let total = 0;
                list.forEach(function (x) {
                    x.rangos.forEach(function (d) {
                        if (d.name === rango) {
                            total += d.numComensales;
                        }
                    })
                });

                return total;
            },


            openModal() {

                this.$modal.show('filtradoTPV');

            },
            getTotalTotal(list, rango) {

                let total = 0;
                this.data.forEach(function (x) {
                    x.rangos.forEach(function (d) {
                        total += d.amount;

                    })
                });

                return total;
            },
            getTotalOps(list) {

                let total = 0;
                list.forEach(function (x) {
                    x.rangos.forEach(function (d) {
                        total += d.numOperaciones;
                    })
                });

                return total;
            },
            getTotalComensales(rango) {

                let total = 0;
                this.data.forEach(function (x) {

                    x.rangos.forEach(function (d) {
                        total += d.numComensales;

                    })
                });

                return total;
            },


            getBusiness() {
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
                    .then(function (response) {

                        vm.listBusinesses = response.data.result;


                        if (vm.$store.getters.idBusiness) {
                            vm.idBusiness = vm.$store.getters.idBusiness;
                        }
                        else {

                            vm.idBusiness = response.data.result[0].id;
                        }


                        vm.getTpv();

                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },


            getTpv() {
                if (this.idBusiness.length > 0) {

                    this.listTpv = [];

                    var config = {
                        params: {
                            idBusiness: this.idBusiness,
                            jwt: this.$store.getters.jwt
                        },
                        headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                    };

                    let vm = this;
                    this.axios.get(this.$store.getters.apiUrl + "general/getTpvsByBusiness", config)
                        .then(function (response) {
                            if (response.data.response) {


                                for (let i = 0; i < response.data.result.length; i++) {
                                    vm.idsTPV.push(response.data.result[i].id)
                                }

                                vm.listCheckBoxTpv = response.data.result;

                                /*let printer = {
                                    nameShow: vm.$t('todos'),
                                    id: 0
                                };
                                vm.listTpv.push(printer);*/

                                for (let i = 0; i < response.data.result.length; i++) {

                                    let printername = {
                                        nameShow: response.data.result[i].nameShow,
                                        id: response.data.result[i].id
                                    };

                                    vm.listTpv.push(printername)
                                }


                                //vm.getVentas();


                            }

                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                }

            },

            getVentas() {
                this.$modal.hide('filtradoTPV');

                if (this.idBusiness.length > 0) {

                    if (this.datefrom === null || this.dateto === null) {

                        this.loading.close();
                        swal({
                            title: this.$t('ups'),
                            text: this.$t('seleccioneUnaFechaDeInicioYUnaFechaDeFin'),
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });

                    } else {

                        this.getVentasRangoHorario();


                    }
                }

            },

            getVentasRangoHorario() {

                let secondsDesde = moment(this.datefrom).startOf("day").unix();
                let secondsHasta = moment(this.dateto).endOf("day").unix();

                if (secondsHasta < secondsDesde) {

                    this.loading.close();

                    swal({
                        title: this.$t('ups'),
                        text: this.$t('laFechaDeInicioNoPuedeSerPosteriorALaDeFin'),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });
                } else {

                    this.$store.dispatch("setDateTo", this.dateto);
                    this.$store.dispatch("setDateFrom", this.datefrom);

                    var config = {
                        params: {
                            idBusiness: this.idBusiness,
                            idTpv: this.idsTPV,
                            datefrom: secondsDesde,
                            dateto: secondsHasta,
                            diferenciaHoraria: Intl.DateTimeFormat().resolvedOptions().timeZone,
                            consultarInicioCuenta: this.consultarInicioCuenta,
                            jwt: this.$store.getters.jwt
                        },
                        headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                    };
                    
                    this.loading = Loading.service({ text: "Cargando..." });
                    let vm = this;
                    this.$store.dispatch("setIdBusiness", this.idBusiness);
                    this.axios.get(this.$store.getters.apiUrl + "rangosHorarios/getSalesByRangoHorario", config)
                        .then(function (response) {
                            if (response.data.response) {

                                vm.respuesta=true;

                                vm.data = response.data.result.data;

                                if (response.data.result.rangosHorarios != null) {
                                    vm.rangosHorarios = response.data.result.rangosHorarios;
                                    vm.initChartOperaciones();
                                    vm.initChartComensales();

                                    if (vm.permiso) {

                                    
                                        if (response.data.result.rangosHorarios.length === 0) {
                                            swal({
                                                title: vm.$t('noTienesNingunRangoDeFechaCreadoDeseasCrearUnRangoDeFecha'),
                                                type: 'info',
                                                showCancelButton: true,
                                                confirmButtonClass: 'btn btn-success btn-fill',
                                                cancelButtonClass: 'btn btn-danger btn-fill',
                                                confirmButtonText: vm.$t('siCrearUnRangoHorario'),
                                                cancelButtonText: vm.$t('cancelar'),
                                                buttonsStyling: true
                                            }).then((result) => {
                                                if (result.value) {

                                                    vm.$router.push({
                                                        name: 'rangos-horarios',
                                                    })
                                                }
                                            });
                                        }
                                    }
                                }

                            }else if (response.data.response == false && response.data.rangoMayor == true) {
                                    swal({
                                    title: "Lo sentimos",
                                    text: response.data.result,
                                    confirmButtonClass: "btn btn-info btn-fill",
                                    type: "info",
                                    });
                                    vm.respuesta = false;
                            } 
                            else {
                                swal({
                                    title: vm.$t('atencion'),
                                    text: response.data.message,
                                    confirmButtonClass: 'btn btn-info btn-fill',
                                    type: 'error'
                                });

                                vm.respuesta=false;
                            }
                            vm.loading.close();
                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                }

            },
            getTotalNumComenOfRangos(rangos) {
                let total = 0;

                rangos.forEach(function (d) {
                    total += d.numComensales;
                });

                return total;
            },
            getTotalnumOperacionesOfRangos(rangos) {
                let total = 0;

                rangos.forEach(function (d) {
                    total += d.numOperaciones;
                });

                return total;
            },

            getTotalVentasOfRangos(rangos) {
                let total = 0;

                rangos.forEach(function (d) {
                    total += d.amount;
                });

                return total;
            },
            getClassDay(date) {
                var classDay = "";
                var humanDate = moment.unix(date);
                var dia = moment(humanDate).format("d");

                if (dia === "0") {
                    classDay = "sunday";
                } else if (dia == 5 || dia == 6) {
                    classDay = "fridaySaturday";
                }

                return classDay;
            },

            initChartOperaciones() {
                let vm = this;
                var labels = vm.rangosHorarios.map(function (x) {
                    return x.name;
                });

                // let total = 0;
                // let count = 0;

                // var labelsMedia = this.data.map(function (x) {
                //
                //     count++;
                //
                //     total += x.money + x.checks + x.cards;
                //
                //     return total / count;
                // });

                var data = vm.rangosHorarios.map(function (x) {
                    return vm.getTotal(vm.data, x.name);
                });

                var dataOps = vm.rangosHorarios.map(function (x) {
                    return vm.getOps(vm.data, x.name);
                });

                if (this.objectChartOps !== null) {
                    this.objectChartOps.destroy();
                }

                this.objectChartOps = new Chart('chartOperaciones', {

                    type: 'horizontalBar',
                    data: {
                        labels: labels,
                        datasets: [
                            {
                                label: vm.$t('total'),
                                data: data,
                                backgroundColor: "rgba(14, 163, 41, 0.6)",
                                borderWidth: 1
                            },
                            {
                                label: vm.$t('operaciones'),
                                data: dataOps,
                                backgroundColor: "rgba(6, 153, 148, 0.6)",
                                borderWidth: 1
                            }
                        ]
                    },
                    options: {
                        legend: {
                            display: false,
                            position: 'bottom',
                        },
                        maintainAspectRatio: false,
                    }
                });

            },
            initChartComensales() {

                let vm = this;
                var labels = vm.rangosHorarios.map(function (x) {
                    return x.name;
                });

                // let total = 0;
                // let count = 0;

                // var labelsMedia = this.data.map(function (x) {
                //
                //     count++;
                //
                //     total += x.money + x.checks + x.cards;
                //
                //     return total / count;
                // });

                var data = vm.rangosHorarios.map(function (x) {
                    return vm.getTotal(vm.data, x.name);
                });

                var dataComensales = vm.rangosHorarios.map(function (x) {
                    return vm.getComensales(vm.data, x.name);
                });

                if (this.objectChartComensales !== null) {
                    this.objectChartComensales.destroy();
                }

                this.objectChartComensales = new Chart('chartComensales', {

                    type: 'horizontalBar',
                    data: {
                        labels: labels,
                        datasets: [
                            {
                                label: vm.$t('total'),
                                data: data,
                                backgroundColor: "rgba(14, 163, 41, 0.6)",
                                borderWidth: 1
                            },
                            {
                                label: vm.$t('comensales'),
                                data: dataComensales,
                                backgroundColor: "rgba(6, 0, 148, 0.6)",
                                borderWidth: 1
                            }
                        ]
                    },
                    options: {
                        legend: {
                            display: false,
                            position: 'bottom',
                        },
                        maintainAspectRatio: false,
                    }
                });

            },
        }


    }
</script>

<style scoped>

    .consultarSwitch {
        padding-top: 6px;
    }

    .el-switch {
        margin: 6px;
        margin-bottom: 5px;
    }

    a li {
        color: #111;
    }

    .card {
        padding: 20px;
    }

    .div-export {
        margin-bottom: 10px;
    }

    .sunday {
        color: rgb(128, 0, 0);
    }

    .fridaySaturday {
        color: rgb(0, 128, 64);
    }

    .trDay:hover {
        background-color: rgba(68, 125, 247, 0.2) !important;
    }


</style>




// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/Ventas/VentasZonaHoraria.vue